var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showWait)?_c('Loading'):_c('div',[_c('PageTitle',{attrs:{"main":`Projeção do Consumo de Insumos`,"sub":"","imagem":"storage.png"}}),_c('MaterialInputPlanGrid')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }